var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{domProps:{"textContent":_vm._s(_vm.header.text)}}),(_vm.header.hint)?_c('BInfo',{attrs:{"icon":"mdi-message-alert-outline","icon-class":"ml-1","text":_vm.header.hint,"size":"1rem"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }